import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION1: PdfComponent = {
  type: 'section',
  id: 'iars1',
  title: '1. Appointment and Purpose',
  content: [
    {
      type: 'bulletList',
      id: 'iars1bullets',
      bulletType: 'number',
      content: [
        {
          copy: {
            type: 'altText',
            id: 'iar11',
            content: [
              'The Principal appoints the Introducer as its ',
              'Introducer Appointed Representative (IAR)',
              ' in accordance with section 39 of the ',
              'Financial Services and Markets Act 2000',
              ' (“the Act”) for the activity of ',
              'credit broking',
              ' only.',
            ],
            boldFirst: false,
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar12',
            content: [
              'The Principal is authorised and regulated by the ',
              'Financial Conduct Authority (FCA)',
              ' for credit broking. It accepts responsibility for any activity carried out by the Introducer under this Agreement, but for no other activities.',
            ],
            boldFirst: false,
          },
        },
        {
          copy: 'The Introducer must not be directly authorised by the FCA. If this status changes, the Introducer must notify the Principal immediately.',
        },
        {
          copy: 'This Agreement is effective from the date stated above.',
        },
      ],
      prefix: '1',
    },
  ],
};
